<template lang="pug">
	a.card(:href="card.file" target="_blank" :class="['card_' + type]")
		.card__category(v-if="card.category" v-text="card.category.name")
		img.card__bg(:src="card.photo ? card.photo[400] : ''")
		.card__info
			.card__number(v-if="type === 'field_new'" v-text="'№' + card.number" style="display: none;")
			.card__title(v-text="card.name")
			.card__text(v-if="type == 'product'" v-text="card.purpose")
			.card__date(v-if="type == 'new' || type === 'video' || type == 'field_new'" v-text="getDate(card.date)")
		.card__btn(v-if="type === 'field_new'") Завантажити pdf
			span
		.card__btn(v-else) Більше
			span
</template>

<script>

	export default {
		name: 'Card',
		props: {
			card: Object,
			type: String,
			link: String
		},
		data: function(){
			return {
				
			}
		},
		methods: {
			getDate(date) {
				let d = new Date(date);
				var dd = d.getDate();
				var mm = d.getMonth() + 1;

				var yyyy = d.getFullYear();
				if (dd < 10) {
					dd = '0' + dd;
				} 
				if (mm < 10) {
					mm = '0' + mm;
				} 
				return dd + '.' + mm + '.' + yyyy;
			}
		}
	}

</script>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';

	.card {
		display: inline-block;
		vertical-align: top;
		width: 305px;
		position: relative;
		box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.05);
		margin: 0 10px 50px;

		&__bg {
			height: auto;
			width: 100%;
			display: block;
			background-size: cover;
			background-position: center;
			background-color: #555;
		}

		&__info {
			padding: 19px 20px 15px;
			background-color: #fff;
		}

		&__date {
			color: #333333;
			font: 14px/16px 'Helvetica', Arial, sans-serif;
			letter-spacing: 1px;
			margin-top: 12px;
		}

		&__btn {
			position: absolute;
			top: 100%;
			right: 0;
			height: 30px;
			width: 152px;
			background-color: #ed3e33;
			color: #fff;
			font: 500 11px/30px 'Helvetica', Arial, sans-serif;
			padding-left: 35px;
			padding-top: 1px;
			letter-spacing: 1.2px;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
			text-transform: uppercase;

			span {
				background-color: #ea3e33;
				display: block;
				position: absolute;
				width: 30px;
				height: 100%;
				right: 0;
				top: 0;
				
				&:after {
					content: "";
					display: block;
					width: 100%;
					height: 100%;
					background: url('../assets/img/btn.svg') no-repeat center center;
					transition: transform .5s ease;
					transform: translate3d(0, 0, 1px);
				}
			}
		}

		&__title {
			@include kit('cardTitle');
			overflow: hidden;
			height: 21px;
			white-space: nowrap;
			text-overflow: ellipsis;
		}

		&__text {
			height: 32px;
			overflow: hidden;
			margin-top: 10px;
			line-height: 16px;
		}

		&_product {
			.card__info {
				padding-bottom: 18px;
			}
		}

		&_new {
			width: 413px;

			.card__info {
				padding: 26px 20px 27px;
			}

			.card__title {
				height: 42px;
				white-space: normal;
			}

			.card__bg {
				height: 206px;
			}
		}

		&_field_new {
			width: calc(25% - 20px);

			.card__info {
				padding: 26px 20px 27px;
			}

			.card__title {
				height: 35px;
				white-space: normal;
			}

			.card__number {
				@include kit('cardTitle');
			}

			.card__bg {
				// height: 206px;
				background-size: 100% auto;
				background-position: center top;
				background-repeat: no-repeat;
			}

			.card__date {
				margin-top: 0;
			}

			.card__btn {
				width: 196px;
				text-align: center;
				padding-right: 30px;
				padding-left: 0;

				span {
					background: url('../assets/img/dwn.svg') no-repeat center center;

					&:after {
						display: none;
					}
				}
			}
		}

		&_video {
			width: 413px;
			box-shadow: none;

			.card__bg {
				height: 224px;
			}

			.card__info {
				background-color: transparent;
				box-shadow: none;
				padding: 19px 0 0;
			}

			.card__btn {
				display: none;
			}

			.card__title {
				font-size: 19px;
				line-height: 21px;
				height: 22px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				margin-left: -3px;
				letter-spacing: .95px;
			}

			.card__date {
				color: #828282;
				font-size: 14px;
				line-height: 16px;
				font-weight: 400;
				margin-top: 0;
				margin-left: -3px;
			}
		}

		&__category {
			position: absolute;
			top: -20px;
			left: 0;
			height: 20px;
			padding: 0 20px;
			background-color: #4D7860;
			text-transform: uppercase;
			color: #fff;
			font: 500 11px/22px 'Helvetica', Arial, sans-serif;
			letter-spacing: 1px;
			min-width: 110px;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
		}
	}

	@media screen and (max-width: 1200px) {
		.card {
			width: 100%;
			margin: 0 0 50px;

			&__btn {
				display: block;
			}

			&__text {
				margin-top: 5px;
			}

			&_field_new {

				.card__title {
					font-size: 14px;
					line-height: 1.3;
					height: 65px;
				}

				.card__date {
					font-size: 11px;
					opacity: 1;
					color: #333333;
				}

				.card__info {
					padding-bottom: 10px;
				}
			}

			&_new {
				.card__title {
					font-size: 14px;
					line-height: 18px;
				}

				.card__info {
					padding-top: 20px;
					padding-bottom: 10px;
				}

				.card__btn {
					display: block;
					top: auto;
					bottom: 0;
					width: auto;
					padding: 0 19px;
					background-color: transparent;
					color: #ea3e33;
					box-shadow: none;

					span {
						display: none;
					}
				}
			}
		}
	}

</style>
